import { render } from "./NetworkError.vue?vue&type=template&id=15b180d1"
import script from "./NetworkError.vue?vue&type=script&lang=js"
export * from "./NetworkError.vue?vue&type=script&lang=js"
script.render = render

export default script